import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { ApiService } from '../../../../../services/lsg.api.service';
import * as CourseCommentsActions from './course-comments.actions';

@Injectable()
export class CourseCommentsEffects {
  constructor(
    private actions$: Actions,
    private apiService: ApiService,
  ) {}
  loadComments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CourseCommentsActions.loadComments),
      mergeMap(({ courseId, itemId, itemType }) =>
        this.apiService.getComments(courseId, itemId, itemType).pipe(
          map((comments: any) => {
            console.log(
              '[Comments Effect] Raw API response:',
              JSON.stringify(comments?.[0], null, 2),
            );
            return CourseCommentsActions.loadCommentsSuccess({ comments });
          }),
          catchError((error) =>
            of(CourseCommentsActions.loadCommentsFailure({ error })),
          ),
        ),
      ),
    ),
  );

  addComment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CourseCommentsActions.addComment),
      mergeMap(({ courseId, payload }) =>
        this.apiService.createComment(courseId, payload).pipe(
          map((res: any) => {
            // Handle potential response structure (doc vs direct object)
            const comment = res.doc || res;
            return CourseCommentsActions.addCommentSuccess({ comment });
          }),
          catchError((error) =>
            of(CourseCommentsActions.addCommentFailure({ error })),
          ),
        ),
      ),
    ),
  );

  updateComment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CourseCommentsActions.updateComment),
      mergeMap(({ courseId, commentId, payload }) =>
        this.apiService.updateComment(courseId, commentId, payload).pipe(
          map((res: any) => {
            const comment = res.doc || res;
            return CourseCommentsActions.updateCommentSuccess({ comment });
          }),
          catchError((error) =>
            of(CourseCommentsActions.updateCommentFailure({ error })),
          ),
        ),
      ),
    ),
  );

  deleteComment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CourseCommentsActions.deleteComment),
      mergeMap(({ courseId, commentId }) =>
        this.apiService.deleteComment(courseId, commentId).pipe(
          map(() => CourseCommentsActions.deleteCommentSuccess({ commentId })),
          catchError((error) =>
            of(CourseCommentsActions.deleteCommentFailure({ error })),
          ),
        ),
      ),
    ),
  );
}
